import Auth from '../auth/Auth';
import { AdminUserModel } from "../models/AdminUserModel";
import { WebClient } from './WebClient'

class AdminUsers extends WebClient {
    async getAdminUsers(): Promise<AdminUserModel[]> {
        const url = "/adminusers";

        return this.get(url, Auth.getAuthToken()).then(res => {
            if (res.status === 200) {
                return res.data || [];
            }
            return [];
        }).catch(() => { return []; });
    }

    async getAdminUser(adminUserId: number): Promise<AdminUserModel> {
        const url = `/adminusers/${adminUserId}`;

        return this.get(url, Auth.getAuthToken()).then(res => {
            if (res.status === 200) {
                return res.data;
            }
            return;
        }).catch(() => { return; });
    }

    async updateAdminUser(data: AdminUserModel): Promise<AdminUserModel> {
        return this.post("/adminusers", data, Auth.getAuthToken()).then(res => {
            if (res.status === 200) {
                return res.data;
            }
            return null;
        }).catch(() => { return null; });
    }

    async deleteAdminUser(adminUserId: number): Promise<boolean> {
        return this.delete(`/adminusers/${adminUserId}`, Auth.getAuthToken()).then(res => {
            return res.status === 200;
        }).catch(() => { return false; });
    }
}

export default new AdminUsers();
